import defaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let mixpanelKey = "ae10b159490a18eeb1b9abb20c522240";
let ERTag = "effe6a9252044687961b9ed4c0ddc123";

if (process.env.ENV === "production") {
  mixpanelKey = "743d5fc28fe620777e043be444a3440a";
  ERTag = "e107935f2c5843a791aab820999d5177";
}

export default class analyticsConfig extends defaultAnalyticsConfig {
  // Mixpanel
  static mixpanelToken = mixpanelKey;
  static mixpanelDebug = false;
  // ER
  static erTag = ERTag;
  static erUserReferenceType = "subscriptionReference";

  static cmp = {
    hasPreferenceView: true,
    performanceCategory: 2,
    features: {
      socialSharing: false,
      ER: true,
      Mixpanel: true,
    },

    ER: {
      categoryId: 2,
    },
    Mixpanel: {
      categoryId: 2,
    },
  };
}



// WEBPACK FOOTER //
// ./clients/dmg-sco/js/analyticsConfig.js